// 返回项目根地址
const getRootPath = () => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}`;
    
}

export default getRootPath;